import { useEffect } from "react"
import type { UseFormReturn } from "react-hook-form"

import { useGetInventoryPalletGroups } from "../../../hooks"
import { getPalletsWithMissingLotDetailsFilled } from "../utils/transfer"

interface UseTransferPalletSelectionMissingLotDetailsFillParams<
  TPalletFormValues extends { referenceNbr: number; lots: { rawInventoryId: string }[] },
> {
  form: UseFormReturn<{ pallets: TPalletFormValues[] }>
  productExternalSystemId: string
  warehouseAreaExternalSystemId: string
}

export const useTransferPalletSelectionMissingLotDetailsFill = <
  TPalletFormValues extends { referenceNbr: number; lots: { rawInventoryId: string }[] },
>({
  form,
  productExternalSystemId,
  warehouseAreaExternalSystemId,
}: UseTransferPalletSelectionMissingLotDetailsFillParams<TPalletFormValues>): void => {
  // Separate from the filtered pallet groups of the selection table, so search, sort and aisle changes don't affect it.
  const { palletGroups: referencePalletGroups } = useGetInventoryPalletGroups({
    productExternalSystemId,
    warehouseAreaExternalSystemId,
  })

  // Saved lots only carry a few fields, so the rest is filled from the full pallet list once it loads.
  useEffect(() => {
    if (!referencePalletGroups.length) return

    form.reset(
      { pallets: getPalletsWithMissingLotDetailsFilled(form.getValues("pallets"), referencePalletGroups) },
      { keepDirty: true }
    )
  }, [form, referencePalletGroups])
}
